export default "/_next/static/images/723d83dbfe6965556c22f978b5231ae5.jpg";